import SortPopup, { SortOption } from "../../../../components/sort_popup/sort_popup";

export type JobsSortOption = "newest" | "oldest" | "positionAsc" | "companyAsc" | "expirySoonest";

export const DEFAULT_JOBS_SORT_OPTION: JobsSortOption = "newest";

const OPTIONS: SortOption<JobsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
  { value: "positionAsc", label: "Position (A-Z)" },
  { value: "companyAsc", label: "Company (A-Z)" },
  { value: "expirySoonest", label: "Expiry (soonest)" },
];

export function jobsSortOptionLabel(option: JobsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

export function jobsSortOptionToParams(option: JobsSortOption): {
  sortBy: "createdAt" | "job_position" | "company_name" | "expiry_date";
  sortOrder: "ASC" | "DESC";
} {
  switch (option) {
    case "newest":
      return { sortBy: "createdAt", sortOrder: "DESC" };
    case "oldest":
      return { sortBy: "createdAt", sortOrder: "ASC" };
    case "positionAsc":
      return { sortBy: "job_position", sortOrder: "ASC" };
    case "companyAsc":
      return { sortBy: "company_name", sortOrder: "ASC" };
    case "expirySoonest":
      return { sortBy: "expiry_date", sortOrder: "ASC" };
  }
}

export default function SortJobsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: JobsSortOption;
  setSortOption: (option: JobsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Jobs"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
